(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    let activeTrigger;
    const updateReadiness = () => {
      const ready = !!document.querySelector('selector-root#TI358887')?.shadowRoot?.querySelector('.sel-countries button');
      document.querySelectorAll('.header-language-switcher__trigger').forEach(button => {
        button.disabled = !ready;
        button.setAttribute('aria-busy', String(!ready));
      });
      return ready;
    };
    if (!updateReadiness()) {
      const readinessTimer = setInterval(() => {
        if (updateReadiness()) clearInterval(readinessTimer);
      }, 200);
    }
    document.addEventListener('shopify:section:load', updateReadiness);
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.header-language-switcher__trigger');
      if (!trigger) return;
      const selector = document.querySelector('selector-root#TI358887');
      const appButton = selector?.shadowRoot?.querySelector('.sel-countries button');
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!appButton) { updateReadiness(); return; }
      activeTrigger = trigger;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'true');
      appButton.click();
      const outer = document.querySelector('selector-outer#TI358887-selector-outer');
      const modal = outer?.shadowRoot?.querySelector('.sel-modal');
      if (!modal) return;
      const shadow = outer.shadowRoot;
      const dialog = shadow.querySelector('[role="dialog"]');
      if (!shadow.querySelector('[data-header-selector-style]')) {
        const style = document.createElement('style');
        style.dataset.headerSelectorStyle = '';
        style.textContent = `
          .sel-modal-content { width: 560px !important; max-width: calc(100vw - 32px) !important; max-height: min(640px, 80dvh) !important; background: #fff; border-radius: 18px; padding: 56px 24px 24px; overflow: hidden; box-shadow: 0 16px 60px #0002; }
          .sel-modal-overlay { background: #0006 !important; }
          .sel-bothContainer { width: 100%; gap: 20px; min-height: 0; }
          .sel-bothChild { flex: 1; min-width: 0; padding: 0 !important; }
          .sel-itemsContainer { height: 100%; background: transparent !important; }
          .sel-itemsList { min-height: 0; }
          .sel-item { padding: 12px 8px !important; border-radius: 8px; }
          .sel-item[hidden] { display: none !important; }
          .sel-item-container { gap: 10px !important; }
          .sel-modalCheckbox { display: none !important; }
          .sel-title { font-family: var(--font-body-family, Arial, sans-serif) !important; font-size: 14px !important; color: #171717 !important; }
          .sel-item.sel-current { background: #eef0fc !important; }
          .sel-item:not(.sel-current):hover { background: #f5f5f5 !important; }
          .sel-iconWrapper { width: 24px !important; min-width: 24px !important; height: 18px !important; }
          .header-selector-label { margin: 0 0 12px; font: 600 15px/1.4 var(--font-body-family, Arial, sans-serif); color: #171717; }
          .header-selector-close { position: absolute; right: 12px; top: 10px; width: 36px; height: 36px; border: 0; border-radius: 50%; background: #f5f5f5; color: #171717; font: 26px/1 Arial, sans-serif; cursor: pointer; }
          .header-selector-close:focus-visible { outline: 2px solid #006ac8; outline-offset: 2px; }
          @media(max-width: 480px) { .sel-modal-content { padding: 54px 16px 20px; } .sel-bothContainer { gap: 12px; } .sel-title { font-size: 13px !important; } .sel-item-container { gap: 7px !important; } }
        `;
        shadow.append(style);
      }
      const applyCountryLanguages = () => {
        const country = shadow.querySelector('.sel-countries [aria-selected="true"]')?.dataset.code || selector.dataset.country;
        const localLanguage = { LT: 'lt', LV: 'lv', EE: 'et', FI: 'fi' }[country];
        shadow.querySelectorAll('.sel-languages [role="option"]').forEach(option => {
          const allowed = option.dataset.code === 'en' || option.dataset.code === localLanguage;
          option.hidden = !allowed;
          option.setAttribute('aria-disabled', String(!allowed));
        });
      };
      applyCountryLanguages();
      if (!outer.dataset.headerLanguageRules) {
        outer.dataset.headerLanguageRules = 'true';
        new MutationObserver(applyCountryLanguages).observe(shadow.querySelector('.sel-bothContainer'), {
          subtree: true, childList: true, attributes: true, attributeFilter: ['aria-selected']
        });
      }
      [['.sel-countries', selector.dataset.countryLabel], ['.sel-languages', selector.dataset.languageLabel]].forEach(([group, text]) => {
        const container = shadow.querySelector(group + ' .sel-itemsContainer');
        if (!container || container.querySelector('.header-selector-label')) return;
        const heading = document.createElement('h2');
        heading.className = 'header-selector-label';
        heading.textContent = text;
        container.prepend(heading);
        container.querySelector('[role="listbox"]')?.setAttribute('aria-label', text);
      });
      dialog?.setAttribute('aria-label', selector.dataset.countryLabel + ' / ' + selector.dataset.languageLabel);
      if (dialog && !dialog.querySelector('.header-selector-close')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'header-selector-close';
        close.textContent = '×';
        close.setAttribute('aria-label', selector.dataset.closeLabel);
        close.addEventListener('click', () => dialog.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', code: 'Escape', keyCode: 27, bubbles: true, composed: true })));
        dialog.prepend(close);
      }
      trigger.removeAttribute('aria-controls');
      dialog?.focus({ preventScroll: true });
      const observer = new MutationObserver(() => {
        if (modal.classList.contains('sel-modal-active')) return;
        observer.disconnect();
        activeTrigger?.setAttribute('aria-expanded', 'false');
        activeTrigger?.focus({ preventScroll: true });
      });
      observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
